import pinia from '@/presentation/store';

export default {
	name: 'pinia',
	parallel: true,
	setup(app) {
		app.use(pinia);
	},
};
